/**
 * 装配体零部件固定/浮动领域类型。
 *
 * 文件职责：
 * 1. 定义插入零部件时的 SolidWorks 固定/浮动策略；
 * 2. 定义运行时零部件实例的固定状态；
 * 3. 为 cad-core 与 web-client 提供同一套稳定枚举，避免 UI 自行拼字符串。
 */

/**
 * 插入零部件时的固定/浮动策略。
 */
export enum InsertComponentFixationMode {
  /** 仅当当前装配体没有既有零部件时，将本次插入的零部件设为固定。 */
  OnlyFirstComponent = 'only-first-component',
  /** 无论是否已有零部件，本次插入都固定在选定位置。 */
  Fixed = 'fixed',
  /** 无论是否已有零部件，本次插入都保持浮动。 */
  Floating = 'floating',
}

/**
 * 装配体零部件实例固定状态。
 */
export enum AssemblyComponentFixationState {
  /** 固定在装配体中的当前位置，不能通过移动/旋转零部件命令改变位姿。 */
  Fixed = 'fixed',
  /** 取消固定，允许由配合或移动/旋转命令继续定义位姿。 */
  Floating = 'floating',
}

/**
 * 插入零部件的默认固定策略。
 *
 * 说明：
 * SolidWorks 默认语义是“第一个零部件固定、后续零部件浮动”，
 * 因此默认值必须落到 `OnlyFirstComponent`，而不是简单的固定或浮动。
 */
export const DEFAULT_INSERT_COMPONENT_FIXATION_MODE = InsertComponentFixationMode.OnlyFirstComponent;

/**
 * 固定零部件在中文设计树中的前缀。
 */
export const ASSEMBLY_COMPONENT_FIXED_TREE_PREFIX = '(固定)';

/**
 * 浮动且尚未完全定义零部件在设计树中的前缀。
 */
export const ASSEMBLY_COMPONENT_UNDER_DEFINED_TREE_PREFIX = '(-)';
